import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Atividade } from '../../@types';
import Agro1Loader from '../../components/Agro1Loader';
import { AtividadesService } from '../../services';
import Agro1Toast from '../../components/Agro1Toast';

interface PropTypes {
  item: Atividade;
  onDelete: () => Promise<void>;
}

const ActionButtons: FC<PropTypes> = ({ item, onDelete }) => {
  const navigate = useNavigate();

  const handleDelete = useCallback(async () => {
    const loaderId = Agro1Loader.show();

    try {
      await AtividadesService.delete(item.id.toString());

      Agro1Toast.show({
        detail: 'Registro excluído com sucesso.',
        severity: 'success',
      });

      await onDelete();
    } catch (error) {
      console.error(error);

      Agro1Toast.show({
        detail:
          'Falha ao excluir. A atividade está sendo utilizada em outro registro.',
        severity: 'error',
        sticky: true,
      });
    } finally {
      Agro1Loader.close(loaderId);
    }
  }, [item.id, onDelete]);

  const requestHandleDelete = useCallback(() => {
    confirmDialog({
      message: 'Você tem certeza que deseja excluir?',
      header: 'Atenção',
      icon: 'pi pi-info-circle',
      accept: handleDelete,
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptClassName: 'button-danger',
      rejectClassName: 'button-primary',
    });
  }, [handleDelete]);

  return (
    <div className="flex flex-column xl:flex-row ">
      <Button
        className="button-secondary ml-auto xl:mr-1"
        icon="pi pi-trash"
        severity="success"
        onClick={() => requestHandleDelete()}
      />
      <Button
        className="button-secondary mr-auto mt-1 xl:mt-0"
        icon="pi pi-pencil"
        severity="success"
        onClick={() =>
          navigate(`/gerenciador-dados/atividades/edit/${item.id}`)
        }
      />
    </div>
  );
};

export default ActionButtons;
